import React, {PureComponent} from 'react'
import cn from "classnames"
import injectSheet from 'react-jss'

class CentredContentContainer extends PureComponent {

    render() {
        const {classes, className, rootClassName, children, size, extended=false, alignContent} = this.props;

        return <div className={cn(classes.root, rootClassName, {[classes.rootExtended]: extended})} data-cy="centredContainer">
            <div 
                data-cy="centredContainerInner"
                className={cn(classes.centerContainer, className,
                {
                    [classes.centerContainerSmall]: size === "small",
                    [classes.centerContainerLarge]: size === "large",
                    [classes.centerContainerHuge]: size === "huge",
                    [classes.extended]: extended,
                    [classes.alignContentCenter]: alignContent === "center"
                } )}>
                {children}
            </div>
        </div>
    }
}

export default injectSheet((theme) => ({
    root: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        marginLeft: "0",
        marginRight: "0",
        [theme.breakpoint("mobile")]: {
            marginLeft: "1rem",
            marginRight: "1rem",
        }
    },
    rootExtended: {
        marginLeft: "0",
        marginRight: "0",
        [theme.breakpoint("mobile")]: {
            marginLeft: "1rem",
            marginRight: "1rem",
        }
    },
    centerContainer: {
        maxWidth: theme.content.width,
        width: "100%",
        padding: `0 ${theme.spacing.tiny}`,
    },
    centerContainerSmall: {
        maxWidth: theme.content.widthSmall,
        [theme.breakpoint('huge')]: {
            maxWidth: theme.content.width,
        }
    },
    centerContainerLarge: {
        maxWidth: theme.content.widthMedium,
        [theme.breakpoint('huge')]: {
            maxWidth: theme.content.widthLarge,
        }
    },
    centerContainerHuge: {
        maxWidth: theme.content.widthLarge,
        [theme.breakpoint('huge')]: {
            maxWidth: theme.content.widthXLarge,
        }
    },
    alignContentCenter: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        textAlign: "center",
    },
    extended: {
        padding: 0,
        [theme.breakpoint("mobile")]: {
            padding: `0 ${theme.spacing.small}`,
        },
        [theme.breakpoint("tablet")]: {
            padding: `0 ${theme.spacing.large}`,
        },
        [theme.breakpoint("laptop")]: {
            padding: `0 5rem`,
        }

    }
}))(CentredContentContainer)



// WEBPACK FOOTER //
// ./src/components/Widgets/CentredContentContainer.js